const globalName = '_paq';

function initialize(trackerConfig, count, isLast = true) {
  const trackerEndpoint = trackerConfig.url.replace('piwik.js', 'matomo.php');

  // only initialize again, if the trackers are not set already
  // this is needed, since we could have multiple javascript using env/analytics
  // and thus multiple instances trying to set up _paq, which is not allowed
  // (e.g. global.js and form.js in inka)
  if (window[globalName] === undefined) {
    if (count > 0) {
      // add additional trackers by pushing to config with 'addTracker' func
      // we assume an already existing _paq-variable for this
      window[globalName].push([
        'addTracker',
        trackerEndpoint,
        trackerConfig.trackerId,
      ]);
    } else {
      // first tracker, initial config
      window[globalName] = [];
      window[globalName].push(['enableLinkTracking']);
      window[globalName].push(['setTrackerUrl', trackerEndpoint]);
      window[globalName].push(['setSiteId', trackerConfig.trackerId]);
    }
  }

  return {
    set(param, value) {
      if (isLast) {
        window[globalName].push([param, value]);
      }
    },

    setDimension(id, value) {
      if (isLast) {
        window[globalName].push(['setCustomDimension', id, value]);
      }
    },

    trackEvent(category, action, options) {
      // only ever track for the last tracker
      if (isLast) {
        const label = options.label || '';
        const value = (options.value) ? parseFloat(options.value) : undefined;

        // since matomo does not provide useful event-reporting in their
        // backend (except if you buy a custom plugin), we combine the strings
        // to be tracked in category/action/label
        window[globalName].push([
          'trackEvent',
          `${category}: ${action}`, // was category only
          label, // was action
          value, // was label
          '', // was value
        ]);
      }
    },

    trackPageView() {
      // only track and output the 3rd-party-code if we are on the last tracker
      if (isLast) {
        window[globalName].push(['trackPageView']);

        /* eslint-disable */
        (function() {
          var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
          g.async=true; g.defer=true; g.src=trackerConfig.url;
          s.parentNode.insertBefore(g,s);
        })();
        /* eslint-enable */
      }
    },
  };
}

export default {
  initialize,
};
